<template>
  <div class="health-suggestion">
    <el-card>
      <div class="search-box">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-input
              v-model="query.keyword"
              placeholder="请输入内容关键词"
              prefix-icon="el-icon-search"
              @keyup.enter.native="getList"
            />
          </el-col>
          <el-col :span="5">
            <el-select v-model="query.status" placeholder="请选择状态">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="待处理" :value="0"></el-option>
              <el-option label="已处理" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="query.user_id"
              type="number"
              placeholder="请输入用户ID"
            />
          </el-col>
          <el-col :span="8">
            <el-row :gutter="10">
              <el-col :span="11">
                <el-date-picker
                  v-model="query.start_time"
                  type="datetime"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-col>
              <el-col :span="1">
                <span class="date-divider">-</span>
              </el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="query.end_time"
                  type="datetime"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div class="search-buttons">
          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </div>
      </div>

      <div class="table-container">
        <el-table :data="suggestionList" v-loading="loading" style="width: 100%">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
          <el-table-column prop="nickname" label="用户昵称" width="120"></el-table-column>
          <el-table-column prop="mobile" label="联系电话" width="130"></el-table-column>
          <el-table-column prop="content" label="建议内容" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status_text" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
                {{ scope.row.status_text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_time_str" label="提交时间" width="180"></el-table-column>
          <el-table-column prop="update_time_str" label="更新时间" width="180"></el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" @click="getDetail(scope.row)">详情</el-button>
              <el-button 
                size="mini" 
                type="primary" 
                v-if="scope.row.status === 0" 
                @click="handleSuggestion(scope.row)"
              >
                处理
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="query.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="query.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 详情对话框 -->
    <el-dialog
      title="建议详情"
      :visible.sync="detailVisible"
      width="600px"
    >
      <div v-if="detailInfo" class="detail-content">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="用户ID">{{ detailInfo.user_id }}</el-descriptions-item>
          <el-descriptions-item label="用户昵称">{{ detailInfo.nickname }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detailInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="建议内容">{{ detailInfo.content }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="detailInfo.status === 1 ? 'success' : 'warning'" size="small">
              {{ detailInfo.status_text }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="提交时间">{{ detailInfo.create_time_str }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{ detailInfo.update_time_str || '-' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 图片展示 -->
        <div v-if="detailInfo.images && detailInfo.images.length > 0" class="images-section">
          <h4 class="images-title">
            <i class="el-icon-picture"></i>
            图片附件
          </h4>
          <div class="images-grid">
            <div 
              v-for="(image, index) in detailInfo.images" 
              :key="index" 
              class="image-item"
              @click="previewImage(image)"
            >
              <img :src="image" class="preview-image" />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 处理对话框 -->
    <el-dialog
      title="处理建议"
      :visible.sync="handleVisible"
      width="400px"
    >
      <el-form :model="handleForm" ref="handleForm">
        <el-form-item label="处理状态">
          <el-select v-model="handleForm.status" placeholder="请选择处理状态">
            <el-option label="已处理" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmHandle">确认处理</el-button>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-image-viewer
      v-if="previewImageUrl"
      :url-list="[previewImageUrl]"
      :visible.sync="previewVisible"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  name: 'LeifengHealthSuggestion',
  data() {
    return {
      loading: false,
      suggestionList: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        status: -1,
        user_id: '',
        keyword: '',
        start_time: '',
        end_time: ''
      },
      detailVisible: false,
      detailInfo: {},
      handleVisible: false,
      handleForm: {
        status: 1
      },
      currentId: null,
      previewImageUrl: '',
      previewVisible: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (params.status === -1) delete params.status
        if (!params.user_id) delete params.user_id
        
        const { data: res } = await this.$axios.post('/admin/leifeng_order/suggestionList', params)
        if (res.code === 1) {
          this.suggestionList = res.data.list || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '获取建议列表失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(size) {
      this.query.limit = size
      this.getList()
    },
    handlePageChange(page) {
      this.query.page = page
      this.getList()
    },
    resetQuery() {
      this.query = {
        page: 1,
        limit: 20,
        status: -1,
        user_id: '',
        keyword: '',
        start_time: '',
        end_time: ''
      }
      this.getList()
    },
    async getDetail(row) {
      this.detailInfo = row
      this.detailVisible = true
    },
    handleSuggestion(row) {
      this.currentId = row.id
      this.handleForm = { status: 1 }
      this.handleVisible = true
    },
    async confirmHandle() {
      try {
        const { data: res } = await this.$axios.post('/admin/leifeng_order/suggestionHandle', {
          id: this.currentId
        })
        if (res.code === 1) {
          this.$message.success('处理成功')
          this.handleVisible = false
          this.getList()
        } else {
          this.$message.error(res.message || '处理失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      }
    },
    previewImage(url) {
      this.previewImageUrl = url
      this.previewVisible = true
    }
  }
}
</script>

<style scoped>
.health-suggestion {
  padding: 20px 0;
}

.search-box {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.search-buttons {
  margin-top: 15px;
}

.search-buttons .el-button {
  margin-right: 10px;
}

.date-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
}

.table-container {
  margin-top: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}

.detail-content {
  padding: 10px 0;
}

.images-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.images-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.images-title i {
  color: #409eff;
}

.images-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.image-item {
  width: 100px;
  height: 100px;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.el-table {
  font-size: 13px;
}

.el-table__body-wrapper {
  overflow-x: auto;
}

@media screen and (max-width: 768px) {
  .search-box {
    padding-bottom: 15px;
  }
  
  .el-col {
    margin-bottom: 10px;
  }
  
  .el-dialog {
    width: 95% !important;
  }
  
  .images-grid {
    gap: 8px;
  }
  
  .image-item {
    width: 80px;
    height: 80px;
  }
}
</style>
